import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'mh-core-lib-time-imput',
    templateUrl: './time-imput.component.html',
    styleUrls: ['./time-imput.component.scss'],
    standalone: false
})
export class CoreLibTimeImputComponent {
  @Input() label: string;
  @Output() timeChange = new EventEmitter<string>();

  onTimeChange(event: Event) {
    const time = (event.target as HTMLInputElement).value;
    this.timeChange.emit(time);
  }
}
